module.exports = __webpack_public_path__ + "img/section-others.fcfabc70.png";